import { EffectOptions } from '../../app/state/effects-middleware';
import { isFetchSuccessAction } from '../../middleware';
import {
    FETCH_SESSION_NAME,
    sessionExtended
} from '../session.actions';

export function sessionLifecycleEffects ({
    action, dispatch
}: EffectOptions) {
    /**
     * When the a successful extend session request is made,
     * the current token's session is extended.
     */
    if (isFetchSuccessAction(FETCH_SESSION_NAME, action)) {
        dispatch(sessionExtended());
    }
}
